import type { TableSortState } from '../UI';

// The name column's sort key, shared because the default sort below has to
// point at the same column `getInterventionRoomPropertiesColumns` renders. A
// mismatch renders unsorted with nothing reported, so this and its test are
// the guard.
export const INTERVENTION_ROOM_PROPERTY_NAME_COLUMN_KEY = 'name';

// Intervention room properties arrived in creation order, same as the room
// needs they mirror (REH-301). Ordering is Danish for every user; see
// SORT_LOCALE.
export const DEFAULT_INTERVENTION_ROOM_PROPERTIES_SORT: TableSortState = {
  key: INTERVENTION_ROOM_PROPERTY_NAME_COLUMN_KEY,
  direction: 'asc'
};
